import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '0.65rem',
    fontWeight: 700,
    letterSpacing: 0.5,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  value: {
    fontWeight: 'bold',
    overflow: 'hidden',
    lineHeight: '24px',
    wordBreak: 'break-word',
  },
}));

const ANNOTATION_MAP: { key: string; label: string }[] = [
  { key: 'konecta.com/raised-on-behalf-of', label: 'Requested by' },
  { key: 'konecta.com/owner-email', label: 'Owner email' },
  { key: 'konecta.com/headquarters', label: 'Headquarters' },
  { key: 'konecta.com/headquarters-office', label: 'Office / City' },
  { key: 'konecta.com/account', label: 'Account' },
  { key: 'konecta.com/department', label: 'Department' },
  { key: 'konecta.com/reason', label: 'Reason' },
  { key: 'konecta.com/jira-issue', label: 'Jira Issue' },
  { key: 'konecta.com/java-version', label: 'Java version' },
  { key: 'konecta.com/spring-boot-version', label: 'Spring Boot version' },
  { key: 'konecta.com/python-version', label: 'Python version' },
  { key: 'konecta.com/package-name', label: 'Package' },
];

export const EntityKonectaInfoCard = ({
  variant,
}: {
  variant?: 'gridItem';
}) => {
  const classes = useStyles();
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};

  const fields = ANNOTATION_MAP.filter(({ key }) => annotations[key]);

  if (fields.length === 0) {
    return null;
  }

  return (
    <Card variant={variant === 'gridItem' ? 'outlined' : undefined}>
      <CardHeader title="Konecta Info" />
      <Divider />
      <CardContent>
        <Grid container>
          {fields.map(({ key, label }) => (
            <Grid item xs={12} sm={6} key={key} style={{ paddingBottom: 12 }}>
              <Typography variant="body2" className={classes.label}>
                {label}
              </Typography>
              <Typography variant="body2" className={classes.value}>
                {annotations[key]}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};
